import React from 'react';
import { motion } from 'framer-motion';
import { Wheat, Shield, Award, Heart } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const FeaturesSection = () => {
  const { t } = useLanguage();

  const features = [
    {
      icon: Wheat,
      title: t('features.fresh.title'),
      description: t('features.fresh.desc'),
      color: '#9F3E1F'
    },
    {
      icon: Shield,
      title: t('features.halal.title'),
      description: t('features.halal.desc'),
      color: '#D4AF37'
    },
    {
      icon: Award,
      title: t('features.quality.title'),
      description: t('features.quality.desc'),
      color: '#9F3E1F'
    },
    {
      icon: Heart,
      title: t('features.family.title'),
      description: t('features.family.desc'),
      color: '#D4AF37'
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 }
  };

  return (
    <section className="py-20 bg-[#2D2A26]" data-testid="features-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="font-playfair text-3xl sm:text-4xl font-bold text-[#FDFBF7] mb-4">
            {t('features.title')}
          </h2>
          <div className="w-24 h-1 bg-[#9F3E1F] mx-auto rounded-full" />
        </motion.div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid md:grid-cols-2 lg:grid-cols-4 gap-8"
        >
          {features.map((feature, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              className="bg-[#1A1816] rounded-2xl p-8 text-center shadow-lg hover:shadow-xl transition-shadow border border-[#FDFBF7]/5"
              whileHover={{ y: -5 }}
              data-testid={`feature-${index}`}
            >
              <div
                className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6"
                style={{ backgroundColor: `${feature.color}15` }}
              >
                <feature.icon size={32} style={{ color: feature.color }} />
              </div>
              <h3 className="font-playfair text-xl font-bold text-[#FDFBF7] mb-3">
                {feature.title}
              </h3>
              <p className="font-manrope text-[#FDFBF7]/70">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default FeaturesSection;
